import DialogBox from "components/lib-ui/DialogBox";
import IconBtn from "components/lib-ui/IconBtn";
import { RelocationForm } from "features/candidate/candidate-form/RelocationForm";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import SectionRow from "features/candidate/candidate-view/SectionRow";
import { useState } from "react";
import { Chip, Stack, Typography } from "@mui/material";

export const RelocationSectionRow = ({ options, candidate }) => {
    const [isDialogOpen, setIsDialogOpen] = useState(false);

    const handleDialogOpen = () => {
        setIsDialogOpen(true);
    };
    let relocationJSX = null;
    if (candidate?.relocation === null || candidate?.relocation === undefined) {
        relocationJSX = (
            <>
                    <Typography variant="body2">
                        No relocation information available.
                    </Typography>
            </>
        );
    }

    

    if (candidate?.relocation?.availability === false) {
        relocationJSX = (
            <Typography variant="body2">
                Candidate is not willing to relocate.
            </Typography>
        );
    }

    if (candidate?.relocation?.relocateAnywhere === true) {
        relocationJSX = (
            <Typography variant="body2">
                Candidate is willing to relocate anywhere.
            </Typography>
        );
    }

    if (
        candidate?.relocation?.availability === true &&
        candidate?.relocation?.relocateAnywhere === false
    ) {
        relocationJSX = (
            <Stack spacing={1} sx={{ width: "100%" }}>
                {candidate.relocation?.included.length > 0 && (
                    <Stack spacing={1} sx={{ width: "100%" }}>
                        <Typography variant="body2">
                            Candidate is willing to relocate to:
                        </Typography>
                        <Stack direction="row" gap={1} flexWrap="wrap">
                            {candidate.relocation
                                ? candidate.relocation.included.map((item) => (
                                      <Chip
                                          key={item.id}
                                          label={`${item.title}`}
                                          color="primary"
                                      ></Chip>
                                  ))
                                : null}
                        </Stack>
                    </Stack>
                )}
                {candidate.relocation?.excluded.length > 0 && (
                    <Stack spacing={1} sx={{ width: "100%" }}>
                        <Typography variant="body2">
                            Candidate is NOT willing to relocate to:
                        </Typography>
                        <Stack
                            direction="row"
                            spacing={1}
                            flexWrap="wrap"
                            sx={{ mb: 1 }}
                        >
                            {candidate.relocation
                                ? candidate.relocation.excluded.map((item) => (
                                      <Chip
                                          key={item.id}
                                          label={`${item.title}`}
                                          color="error"
                                      ></Chip>
                                  ))
                                : null}
                        </Stack>
                    </Stack>
                )}
            </Stack>
        );
    }

    return (
        <>
            <SectionRow title="Relocation Locations">
                {relocationJSX}
                <IconBtn
                    sx={{
                        opacity: 0,
                        pointerEvents: "none",
                        marginLeft: "auto",
                        border: "unset",
                        background: "white",
                        position: "absolute",
                        right: 0,
                        top: 1,
                        transform: " translateY('-50')",
                    }}
                    icon={EditOutlinedIcon}
                    onClick={handleDialogOpen}
                ></IconBtn>
            </SectionRow>
            <DialogBox
                isDialogOpen={isDialogOpen}
                setIsDialogOpen={setIsDialogOpen}
                title="Add Relocation Locations"
                floatCancel={true}
                showActionButtons={false}
            >
                <RelocationForm
                    setIsDialogOpen={setIsDialogOpen}
                    options={options}
                />
            </DialogBox>
        </>
    );
};
